import { redirect } from "@tanstack/react-router"
import { toast } from "react-toastify"
import { canAccessTestSupport } from "./testSupport"

export function checkTestSupportAccess() {
  if (!canAccessTestSupport()) {
    toast.error("Je hebt geen toegang tot Test support.")
    throw redirect({ to: "/", replace: true })
  }
}
